import { useState } from "react"

import { openUrlModal } from "@/components/modal/url"

export type OtpSheetState = {
  email: string
} | null

export const useOtpSheet = () => {
  const [otp, setOtp] = useState<OtpSheetState>(null)

  const openOtpSheet = (email: string) => {
    setOtp({ email })
  }

  const closeOtpSheet = () => {
    setOtp(null)
  }

  const handleOtpVerificationSuccess = () => {
    closeOtpSheet()
    openUrlModal("onboarding")
  }

  return {
    isOtpSheetOpen: otp !== null,
    registeredEmail: otp?.email ?? "",
    openOtpSheet,
    closeOtpSheet,
    handleOtpVerificationSuccess
  }
}
